function NotFound() {
  return (
    <div>Sorry, page does not exist.</div>
  )
}

export default NotFound;